/**
 * @documental
 * @export Custom
 * @name
 * Table.Custom
 */
import { FC } from "react";

import { getProperty } from "dot-prop";

import { BaseColumnProps, ColumnRenderFunction } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { useTableRow } from "../useTableRow";

import styles from "./styles.module.css";

/**
 * The `Custom` component properties.
 */
export interface CustomProps extends BaseColumnProps {
  /**
   * The component template.
   */
  readonly children?: ColumnRenderFunction<object>;
}

/**
 * Column which displays a custom component representing a value.
 */
export const Custom: FC<CustomProps> = (props) => {
  const { name, children, align } = props;

  const tableRow = useTableRow();

  if (tableRow === null) return null;

  const { data } = tableRow;

  if (data === null) return null;

  const value = getProperty(data, name, null);

  return <div className={styles.Custom + `${align}`}>{children?.(value, tableRow.id, tableRow)}</div>;
};

(Custom as ColumnElementConstructor<CustomProps>).className = "custom";
